import PropTypes from 'prop-types';
import React from 'react';
import styles from './Textarea.less';

export default class extends React.Component {
    static propTypes = {
        value: PropTypes.string,
        className: PropTypes.string,
        placeholder: PropTypes.string,
        placeholderClass: PropTypes.string,
        focusClass: PropTypes.string,
        onChange: PropTypes.func,
        resize: PropTypes.string,
        focusOnLoad: PropTypes.bool,
        tabIndex: PropTypes.number,
        onFocus: PropTypes.func,
        onBlur: PropTypes.func
    };

    static defaultProps = {
        onChange: () => {},
        resize: 'none',
        tabIndex: 0,
        onFocus: () => {},
        onBlur: () => {}
    };

    constructor(props) {
        super(props);
        this.uniqueId = `${Math.random()}`;

        this.state = {
            isFocused: false
        };
    }

    componentDidMount() {
        if (this.props.focusOnLoad) {
            this.textarea.focus();
        }
    }

    render() {
        const { placeholder, placeholderClass, onChange, value, resize, tabIndex, label} = this.props;
        const className = this._getClassName();
        return (
            <div className={`${className} ${placeholderClass}`}>
                <label htmlFor={`textarea-label_${this.uniqueId}`}>{label}</label>
                <textarea maxLength="490" ref={el => this.textarea = el} cols='75' rows='2'
                          value={value || ''} placeholder={placeholder}
                          style={{resize}}
                          onChange={e => onChange(e.target.value)}
                          onKeyPress={this._onKeyPress}
                          tabIndex={tabIndex}
                          onFocus={this._onFocus}
                          id={`textarea-label_${this.uniqueId}`}
                          onBlur={this._onBlur}/>
            </div>
        );
    }

    _onKeyPress = () => {
        if (this.textarea.value && this.textarea.value.length >= 500) {
            return false;
        }
        return true;
    };

    _onFocus = () => {
        const { onFocus } = this.props;
        this.setState({isFocused: true});
        onFocus();
    };

    _onBlur = () => {
        const { onBlur } = this.props;
        this.setState({isFocused: false});
        onBlur();
    };

    _getClassName = () => {
        const { isFocused } = this.state;
        const { className, value, focusClass } = this.props;
        let cls = `${styles.wrapper} ${className || ''}`;

        if (value) {
            cls += ` ${styles.dirty}`;
        }
        if (isFocused && focusClass) {
            cls += ` ${focusClass}`;
        }

        return cls;
    };
}
